import { END_POINTS, REQUEST_TYPE } from "../lib/variables";
import Api from "./index";

const createUserAddress = (_, payload) => {
  return Api(END_POINTS.createUserAddress, payload, REQUEST_TYPE.POST);
};

const getUserAddress = (id) => {
  return Api(`${END_POINTS.getUserAddress}/${id}`, null, REQUEST_TYPE.GET);
};

const getUserAddressDetail = (id) => {
  return Api(`${END_POINTS.getUserAddressDetail}/${id}`, null, REQUEST_TYPE.GET);
};

const updateUserAddress = (id, payload) => {
  return Api(`${END_POINTS.updateUserAddress}/${id}`, payload, REQUEST_TYPE.PUT);
};

const deleteUserAddress = (id, payload) => {
  return Api(`${END_POINTS.deleteUserAddress}/${id}`, payload, REQUEST_TYPE.DELETE);
};

export {
  createUserAddress,
  getUserAddress,
  getUserAddressDetail,
  updateUserAddress,
  deleteUserAddress,
};
